import InnerComponent from '@Components/Sales/SalesOrder/SalesForm';
import orgContainer from '@Components/AppContainer';

const CreateSalesOrder = () => ((orgContainer(InnerComponent)));
export default CreateSalesOrder;
